<script setup lang="ts">
import { useI18n } from "vue-i18n";
import type { ReportType } from "@/common/types/report";

import { svgIcon } from "@/common/components";

const { t } = useI18n();

const emit = defineEmits(["edit", "copy", "delete"]);

withDefaults(
  defineProps<{
    data: ReportType;
    editable?: boolean;
  }>(),
  {
    editable: true,
  }
);
</script>

<template>
  <section class="card-report">
    <div class="content">
      <div class="name">
        {{ data.name }}
      </div>
      <div class="description">
        {{ data.description }}
      </div>
    </div>

    <div class="actions">
      <button class="btn btn-sm btn-white" @click="emit('edit')">
        <svg-icon icon="edit" size="1.25rem" />
        <span class="text-3">
          {{ t("common.labels.edit") }}
        </span>
      </button>
      <!-- <button class="btn btn-sm btn-white" @click="emit('copy')">
        <svg-icon icon="copy" size="1.25rem" />
        <span class="text-3">
          {{ t("common.labels.copy") }}
        </span>
      </button> -->
      <button class="btn btn-sm btn-delete" @click="emit('delete')">
        <svg-icon icon="trash" size="1.25rem" />
        <span class="text-3">
          {{ t("common.labels.delete") }}
        </span>
      </button>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.card-report {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 2rem;
  background: var(--white-off);
  padding-block: 0.75rem;
  padding-inline: 0.75rem;
  border: 1px solid transparent;
  border-radius: 0.75rem;

  &:hover {
    border-color: #000;
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .name {
      font-size: 16px;
      font-weight: bold;
    }
  }

  .actions {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 0.75rem;

    button {
      text-transform: uppercase;
      padding-inline: 0.25rem;
      padding-block: 0.25rem;
      min-width: 6.25rem;
    }
  }
}
</style>
